export function validateHerdTotalAnimals(value: number) {
    if (value < 1) {
        return 'Please add an amount of animals';
    } else if (value % 1 !== 0) {
        return 'Please input a whole number';
    }
    return true;
}
